import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Environment } from '@galaxy/core';
import { OAuth2Service, OAuth2ServiceConfig } from '@vendasta/oauth2';
import { devServer } from '../../globals';
import { PartnerRouteParams } from '../core/routeparams';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private oauth2Service: OAuth2Service) {}

  public localLogout(): void {
    this.oauth2Service.localLogout();
  }
}

export function oauth2ConfigFactory(): OAuth2ServiceConfig {
  const config = {
    scopes: ['admin', 'integration-connection'],
    serviceProviderConfigs: {
      [Environment.LOCAL]: {
        serviceProviderId: 'wsp-admin-center',
        redirectUri: 'https://localhost:4200',
        silentRefreshRedirectUri: 'https://localhost:4200/silent-refresh.html',
        clientId: 'c5a86f66-5ed1-4c11-82e3-157088e94831',
      },
      [Environment.DEMO]: {
        serviceProviderId: 'wsp-admin-center',
        redirectUri: 'https://wsp-admin-center-demo.apigateway.co',
        silentRefreshRedirectUri: 'https://wsp-admin-center-demo.apigateway.co/silent-refresh.html',
        clientId: 'c5a86f66-5ed1-4c11-82e3-157088e94831',
      },
      [Environment.PROD]: {
        serviceProviderId: 'wsp-admin-center',
        redirectUri: 'https://wsp-admin-center-prod.apigateway.co',
        silentRefreshRedirectUri: 'https://wsp-admin-center-prod.apigateway.co/silent-refresh.html',
        clientId: 'f6486e6d-740c-48b1-b46e-38923aba92b5',
      },
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    customQueryParamsFunc: (next: ActivatedRouteSnapshot, _: RouterStateSnapshot) => ({
      partner_id: (next.params as PartnerRouteParams).partnerId,
    }),
  };

  if (devServer) {
    config.serviceProviderConfigs[Environment.DEMO] = {
      serviceProviderId: 'wsp-admin-center',
      redirectUri: 'https://localhost:4200',
      silentRefreshRedirectUri: 'https://localhost:4200/silent-refresh.html',
      clientId: 'c5a86f66-5ed1-4c11-82e3-157088e94831',
    };
  }

  return config;
}
